<template>
    <div class="social-media-links">
        <a
            v-for="icon in icons"
            :key="icon.url"
            class="social-media-link"
            :title="pageTitle"
            :target="targetType(icon.type)"
            :href="icon.url"
            @click="onClick(icon.url, icon.type)"
        >
            <BaseImage
                :imgSource="`img/social-media-icons/${icon.type}-icon.svg`"
                :width="width"
                :height="height"
                :alt="icon.type"
            />
        </a>
    </div>
</template>

<script>
export default {
    name: 'SocialMediaLinks',
    components: {
        BaseImage: () => import('@atoms/Image/BaseImage'),
    },
    props: {
        pageTitle: {
            type: String,
        },
        width: {
            type: String,
            default: '28px',
        },
        height: {
            type: String,
            default: '28px',
        },
    },
    data() {
        return {
            icons: [
                {
                    type: 'twitter',
                    url:
                        'https://twitter.com/intent/tweet' +
                        `?text=${encodeURIComponent(this.pageTitle)}` +
                        '%20' +
                        `${encodeURIComponent(document.URL)}`,
                },
                {
                    type: 'facebook',
                    url:
                        'https://www.facebook.com/sharer/sharer.php?u=' +
                        `${encodeURIComponent(document.URL)}`,
                },
                {
                    type: 'telegram',
                    url:
                        'https://t.me/share/url?url=' +
                        `${encodeURIComponent(document.URL)}` +
                        '&text=' +
                        `${encodeURIComponent(document.title)}`,
                },
                {
                    type: 'whatsapp',
                    url:
                        'whatsapp://send?text=' +
                        `${encodeURIComponent(document.title)}` +
                        '%20' +
                        `${encodeURIComponent(document.URL)}`,
                },
            ],
        };
    },
    methods: {
        onClick(url, type) {
            if (this.targetType(type)) {
                window.open(
                    url,
                    'popup',
                    'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'
                );
                return false;
            }
        },
        targetType(type) {
            if (type !== 'email') {
                return 'popup';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.social-media-links {
    display: flex;
    grid-column-gap: 6px;
}
</style>
